import ShipRocketShimmer from './ShipRocketShimmer';

export default ShipRocketShimmer;
